import { render, staticRenderFns } from "./SalaTeorica.vue?vue&type=template&id=88fbc8da&scoped=true"
import script from "./SalaTeorica.vue?vue&type=script&lang=js"
export * from "./SalaTeorica.vue?vue&type=script&lang=js"
import style0 from "./SalaTeorica.vue?vue&type=style&index=0&id=88fbc8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fbc8da",
  null
  
)

export default component.exports